import { cn } from '@/lib/utils';
import { useMemo } from 'react';

import {
  type IStarter,
  useChatSession,
  useConfig
} from '@chainlit/react-client';

import Starter from './Starter';

const defaultStarters: IStarter[] = [
  {
    label: 'Find the right certification',
    message: 'Help me find the right IPMA certification for my experience.'
  },
  {
    label: 'Explain ICB4',
    message: 'Can you explain the IPMA ICB4 standard?'
  },
  {
    label: 'Find upcoming IPMA events',
    message: 'What are the upcoming IPMA events?'
  },
  {
    label: 'How does IPMA certification work?',
    message: 'How does IPMA certification work?'
  }
];

interface Props {
  className?: string;
}

export default function Starters({ className }: Props) {
  const { chatProfile } = useChatSession();
  const { config } = useConfig();

  const starters = useMemo(() => {
    if (chatProfile) {
      const selectedChatProfile = config?.chatProfiles.find(
        (profile) => profile.name === chatProfile
      );
      if (selectedChatProfile?.starters) {
        return selectedChatProfile.starters;
      }
    }
    return config?.starters?.length ? config.starters : defaultStarters;
  }, [config, chatProfile]);

  if (!starters?.length) return null;

  return (
    <div
      id="starters"
      className={cn('grid w-full grid-cols-1 gap-2 sm:grid-cols-2', className)}
    >
      {starters?.map((starter, i) => (
        <Starter key={i} starter={starter} />
      ))}
    </div>
  );
}
